// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import HomeOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/@ant-design/icons/es/icons/HomeOutlined';
export default { HomeOutlined };
